




































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Mutation, Action } from 'vuex-class'
import { openShareScene } from '@bilibili/fe-quick-share'
// import Stage from '@/components/stage.vue'
import Timeline from '@/components/timeLine.vue'
import RightNav from '@/components/rightNav.vue'
import ShareDialog from '@/components/shareDialog.vue'
import WorkTip from '@/components/workTip.vue'
import PagContainer from '@/components/pagContainer.vue'
import Highlight from '@/components/highlight.vue'
import { activityCode, totoalStation, sceneList } from '@/utils/config'
import drawImg from '@/utils/draw'
import { $getUniqueNo } from '@/api'
import { workInfoMap, highlightList } from '@/utils/config'
@Component({
  components: {
    Timeline,
    RightNav,
    ShareDialog,
    WorkTip,
    PagContainer,
    Highlight,
  },
})
export default class Progress extends Vue {
  @State('userInfo') userInfo
  @State('currPoint') currPoint
  @State('qrCodeImg') qrCodeImg
  @State('shareConfig') shareConfig
  @Action('actionPre') actionPre
  @Mutation('setCurrPoint') setCurrPoint
  curInfo: any = sceneList[0]
  showList: any = []
  // nextInfo = sceneList[1]
  isLock = false // 锁滑动
  timer: any = null
  bgName = 'bg'
  shareVisible = false
  changeWork = true
  isHighlight = false
  highlightInfo = {}
  // 当前作品
  get currWorkInfo() {
    return workInfoMap[`step${this.currPoint}`] || workInfoMap[`step1`]
  }
  // 下一个作品
  get nextWorkInfo() {
    return workInfoMap[`step${this.currPoint}`] || workInfoMap[`step1`]
  }

  @Watch('currPoint')
  watchCurrPointChange(newVal, oldVal) {
    console.log('%c val ------> ', 'color:#0f0;', newVal, oldVal)
    // todo 当val是第几个点的时候分批预加载资源
    // 判断是否为站点
    let highlightInfo = highlightList.filter((item) => item.station === newVal)
    if (highlightInfo?.length) {
      this.isHighlight = true
      this.highlightInfo = highlightInfo[0]
    } else {
      this.isHighlight = false
    }
  }

  mounted() {
    // 首页point+1
    if (this.currPoint === 0) {
      this.setCurrPoint(this.currPoint + 1)
    }
    this.showList = [
      Object.assign({}, sceneList[0], {
        show: false,
        page: 0,
      }),
    ]
  }

  // 处理下滑上划
  handleSwipeDown(e: any) {
    const { type } = e
    let isNextPage = type === 'swipeup' || type === 'pointerup'
    let isPrevPage = type === 'swipedown' || type === 'pointerdown'
    let offset = 0
    this.changeWork = !this.changeWork
    if (isNextPage) {
      offset = 1
    }
    if (isPrevPage) {
      offset = -1
    }
    this.changePage(offset)
  }

  changePage(offset) {
    //最小判断
    if (this.currPoint === 1 && offset < 0) return
    //TODO 最大判断，未处理
    if (this.currPoint === totoalStation && offset < 0) return
    // this.currPoint += offset
    this.setCurrPoint(this.currPoint + offset)
    //这里需要做高光时刻的判断
    this.curInfo = sceneList[this.currPoint - 1]

    this.bgName = this.curInfo.isHighlight ? 'highLight' : 'bg'
    //第一次
    const curIndex = this.showList.length < 2 ? 0 : 1
    const info = this.showList[curIndex]
    const obj = JSON.parse(JSON.stringify(info))
    obj.show = true
    this.showList = [
      obj,
      Object.assign({}, this.curInfo, {
        page: this.currPoint,
        show: false,
      }),
    ]
    this.isLock = true
    this.timer = setTimeout(() => {
      this.isLock = false
      clearTimeout(this.timer)
    }, 500)
  }

  // 去分享
  // todo: 保存图片
  handleShare() {
    // Vue.prototype.$logger('sharescorepage_click', { epid: this.epId })
    // 打开分享dialog
    this.actionPre().then(async () => {
      // todo: 请求当前排名的接口
      this.shareVisible = true
      // this.handleUserRank()
      this.handleShareImg()
    })
  }

  // 生成分享图片
  handleShareImg() {
    this.$nextTick(async () => {
      Vue.prototype.$toast.loading('图片生成中，请稍等～')
      try {
        let { face, uname } = this.userInfo
        let res = await drawImg({
          poster: this.currWorkInfo.sharePoster,
          avatar: face,
          userName: uname,
          userRank: '1000',
          qrImg: this.qrCodeImg,
        })
        let shareImg = res && res[0].replace('http', 'https')
        shareImg =
          process.env.NODE_ENV === 'pre'
            ? shareImg.replace('https://', 'https://pre-')
            : shareImg
        console.log('%c 分享的图片地址 ------> ', 'color:#0f0;', shareImg)
        Vue.prototype.$toast.stop()
        this.sharePage(shareImg)
      } catch (error) {
        console.log('%c error ------> ', 'color:#0f0;', error)
        Vue.prototype.$toast.stop()
        Vue.prototype.$toast.info('图片生成失败，请稍后再试～')
      }
    })
  }

  // 分享面板
  async sharePage(val: string) {
    let shareImgs = val
    const { title, description, editContent } = this.shareConfig || {}
    const { origin, pathname } = location || {}
    console.log('%c location ------> ', 'color:#0f0;', location)
    const mainUrl = `${origin}${pathname}?navhide=1`
    console.log('%c mainUrl ------> ', 'color:#0f0;', mainUrl)
    openShareScene({
      business: 'OGV',
      pageId: 'film-history',
      shareScene: 'film-history',
      share2Config: {
        share_id: '',
        share_origin: '',
        oid: mainUrl, // 分享对象id, 配合share_id使用, 对于h5, 传递的是url
        sid: '', // 辅助id, 当oid无法定位的时候, 使用oid+sid来关联
      },
      shareInfo: {
        DEFAULT: {
          type: 'image',
          title,
          avatar: this.userInfo.face,
          url: mainUrl,
          desc: description,
          imageUrl: shareImgs || '',
        },
        BILI_DYNAMIC: {
          description, // read 图片时无作用
          editContent,
          // newTopicId: 33143,
          pictureList: [
            {
              width: 750,
              height: 1334,
              size: 2000,
              src: shareImgs || '',
            },
          ],
        },
      },
      // onClick: async (info: any) => {},
      onSuccess: async () => {
        // closeShareScene && closeShareScene()
      },
    })
  }

  async handleUserRank() {
    let res = await $getUniqueNo({
      activityCode,
    })
    console.log('%c res ------> ', 'color:#0f0;', res)
    console.log('%c res ------> ', 'color:#0f0;', res)
  }
}
